import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

/*
 * Asztali menü controller (xl+ vízszintes menü).
 *
 * A felső szintű elemre húzva nyílik az 1. szintű (teljes szélességű) panel,
 * azon belül egy alelemre húzva nyílik a hozzá tartozó 2. szintű panel.
 * A menüsávról lehúzva, illetve a menün kívülre kattintva minden becsukódik.
 */
export default class extends Controller {
    connect() {
        useClickOutside(this);

        this.navbar = document.getElementById('header-navbar');

        // 1. szint: top-level elem, amihez tartozik almenü.
        this.element.querySelectorAll('.nav-link.lvl1[data-menu]').forEach((link) => {
            link.addEventListener('mouseover', () => this.openLevel1(link.dataset.menu));
        });

        // 1. szint: top-level elem almenü nélkül -> mindent zár (pl. nyelvváltó).
        this.element.querySelectorAll('.nav-link.lvl1:not([data-menu])').forEach((link) => {
            link.addEventListener('mouseover', () => this.closeAll());
        });

        // 2. szint: az 1. szintű panelen belüli, tovább nyíló elemek.
        this.element.querySelectorAll('.submenu-lvl1 .nav-link[data-menu]').forEach((link) => {
            link.addEventListener('mouseover', () => this.openLevel2(link.dataset.menu));
        });

        if (this.navbar) {
            this.onNavbarLeave = () => this.closeAll();
            this.navbar.addEventListener('mouseleave', this.onNavbarLeave);
        }
    }

    disconnect() {
        if (this.navbar && this.onNavbarLeave) {
            this.navbar.removeEventListener('mouseleave', this.onNavbarLeave);
        }
    }

    openLevel1(id) {
        this.hide('.submenu-lvl1');
        this.hide('.submenu-lvl2');
        this.show(id);
        this.refreshArrows();
    }

    openLevel2(id) {
        this.hide('.submenu-lvl2');
        this.show(id);
        this.refreshArrows();
    }

    show(id) {
        if (!id) {
            return;
        }
        const panel = document.getElementById(`menu-${id}`);
        if (!panel) {
            return;
        }
        panel.style.display = 'flex';
        panel.classList.add('active');
    }

    hide(selector) {
        document.querySelectorAll(selector).forEach((el) => {
            el.style.display = 'none';
            el.classList.remove('active');
        });
    }

    closeAll() {
        this.hide('.submenu-lvl1');
        this.hide('.submenu-lvl2');
    }

    // A görgethető paneleknél megmutatja/elrejti a lefelé mutató nyilat.
    refreshArrows() {
        document.querySelectorAll('.submenu .scroll').forEach((scroll) => {
            const arrow = scroll.nextElementSibling;
            if (!arrow) {
                return;
            }
            const overflows = scroll.scrollHeight > scroll.offsetHeight;
            arrow.style.display = overflows ? 'flex' : 'none';
        });
    }

    // stimulus-use: a menün kívülre kattintva minden becsukódik.
    clickOutside() {
        this.closeAll();
    }
}
